// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2ySWe","text":"SelectPayment_text__1Vntv","title":"SelectPayment_title__2USMo","btn":"SelectPayment_btn__2SmQ3"};